import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RadiusUpleftOutlined, SafetyCertificateOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Card, Col, Descriptions, Divider, Flex, Form, Menu, Row } from "antd";
import { useEffect, useState } from "react";
import CertificateNotiForm from "../../components/profile/certificateNotiForm";
import RegulationNotiForm from "../../components/profile/regulationNotiForm";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import MultipleClientForm from "../../components/profile/multipleClientForm";
import { setSelClientList } from "../../context/reducers/userReducer";
import { useNavigate } from "react-router-dom";
import { fetchClientRelatedData } from "../../utils/commonUtil";
import LogoutButton from "../../components/common/logoutButton";
import mdmService from "../../services/MDMService";
export const Profile = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const [current, setCurrent] = useState('1');
    const applicationData = useSelector((state) => state.applicationData);
    const [isRegNotificationEnabled, setIsRegNotificationEnabled] = useState(false);
    const [regFrequency, setRegFrequency] = useState(0);
    const [selMainSubProdList, setSelMainSubProdList] = useState([]);
    const [selRegCountryList, setSelRegCountryList] = useState([]);
    const [selServiceTypeList, setSelServiceTypeList] = useState([]);
    const [isCertOverdueWeekNotiEnabled, setIsCertOverdueWeekNotiEnabled] = useState(false);
    const [isCertImpactRemindNotiEnabled, setIsCertImpactRemindNotiEnabled] = useState(false);
    const [certFrequency, setCertFrequency] = useState(0);
    const [certDecisionPeriod, setCertDecisionPeriod] = useState(0);
    const [certRenewalStatus, setCertRenewalStatus] = useState(0);
    const [saveButtonLoad, setSaveButtonLoad] = useState(false);
    const [dataFetched, setDataFetched] = useState(false);
    const [clientProfileDetails, setClientProfileDetails] = useState(null);
    const dispatch = useDispatch();
    const [multiClientForm] = Form.useForm();
    const navigate = useNavigate();
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 6)) != undefined;
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        setDataFetched(false);
        mdmService
            .getClientProfileDetails({
            intCompanyID: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID,
            strUserId: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId,
        })
            .then((res) => {
            var _a, _b, _c;
            setClientProfileDetails(res);
            if (res) {
                let countryList = [];
                let productList = [];
                let serviceList = [];
                if (((_a = res.lstCountrys) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    countryList = res.lstCountrys
                        .map((_) => { var _a; return (_a = _.intId) === null || _a === void 0 ? void 0 : _a.toString(); })
                        .filter((id) => id !== undefined);
                }
                if (((_b = res.lstProdSubSegment) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    productList = res.lstProdSubSegment
                        .map((_) => { var _a; return (_a = _.intId) === null || _a === void 0 ? void 0 : _a.toString(); })
                        .filter((id) => id !== undefined);
                }
                if (((_c = res.lstServices) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                    serviceList = res.lstServices
                        .map((_) => _.intId)
                        .filter((id) => id !== undefined);
                }
                setSelRegCountryList(countryList);
                setSelMainSubProdList(productList);
                setSelServiceTypeList(serviceList);
                setIsRegNotificationEnabled(res.boolRegImpactRemainFlag);
                setRegFrequency(res.intRegFrequency);
                setIsCertImpactRemindNotiEnabled(res.boolCertImpactRemindFlag);
                setIsCertOverdueWeekNotiEnabled(res.boolCertOverdueWeekFlag);
                setCertFrequency(res.intCertFrequency);
                setCertDecisionPeriod(res.intCertDecisionPeriod);
                setCertRenewalStatus(res.intCertRenewalStatus);
            }
            setSaveButtonLoad(false);
            setDataFetched(true);
        })
            .catch(() => setDataFetched(true)); // Handle errors appropriately
    }, []); // Empty dependency array ensures it runs only once
    const items = [];
    if (applicationData.userRole === 1) {
        items.push({
            key: '1',
            icon: _jsx(SafetyCertificateOutlined, {}),
            label: 'Certificate Notifications',
        });
        items.push({
            key: '2',
            icon: _jsx(RadiusUpleftOutlined, {}),
            label: 'Regulation Notifications',
        });
    }
    if (applicationData.isParentClient) {
        items.push({
            key: '3',
            icon: _jsx(RadiusUpleftOutlined, {}),
            label: 'Multiple Client',
        });
    }
    const onClick = (e) => {
        setCurrent(e.key);
    };
    const onMultiClientSelect = (values) => {
        var _a;
        const filteredMultiClientList = (_a = applicationData.clientList) === null || _a === void 0 ? void 0 : _a.filter((value) => values['lstClient'].includes(value.intId)).map((item, index) => {
            return item;
        });
        dispatch(setSelClientList(filteredMultiClientList));
        fetchClientRelatedData(filteredMultiClientList, dispatch);
        navigate('/dashboard');
    };
    const handleSaveProfileDetails = () => {
        var _a, _b, _c, _d;
        setSaveButtonLoad(true);
        const clientProfileDetails = {
            objLuCompany: {
                intId: (_b = (_a = applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID,
                strLoggedInUser: (_d = (_c = applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId
            },
            lstCountrys: selRegCountryList.map(value => ({ intId: parseInt(value) })),
            lstProdSubSegment: selMainSubProdList.map(value => ({ intId: parseInt(value) })),
            lstServices: selServiceTypeList.map(value => ({ intId: value })),
            boolRegImpactRemainFlag: isRegNotificationEnabled,
            intRegFrequency: regFrequency,
            boolCertImpactRemindFlag: isCertImpactRemindNotiEnabled,
            boolCertOverdueWeekFlag: isCertOverdueWeekNotiEnabled,
            intCertFrequency: certFrequency,
            intCertDecisionPeriod: certDecisionPeriod,
            intCertRenewalStatus: certRenewalStatus
        };
        mdmService.saveClientProfileDetails(clientProfileDetails)
            .then((res) => {
            var _a, _b, _c, _d;
            if (res === "Success") {
                mdmService.getClientProfileDetails({
                    intCompanyID: (_b = (_a = applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID,
                    strUserId: (_d = (_c = applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId
                })
                    .then((res) => {
                    setClientProfileDetails(res);
                    setSaveButtonLoad(false);
                });
            }
        });
    };
    return (_jsxs(Row, { gutter: [16, 16], children: [_jsx(Col, { xs: 24, sm: 24, md: 24, lg: 6, xl: 5, children: _jsxs(Card, { style: { borderRadius: '0px' }, children: [_jsxs(Flex, { align: "center", justify: "center", style: { flexDirection: "column", gap: "20px" }, children: [_jsx(Avatar, { style: { backgroundColor: '#43485F' }, size: 200, icon: _jsx(UserOutlined, {}), shape: "square" }), _jsxs(Descriptions, { children: [_jsx(Descriptions.Item, { label: "User Name", span: 3, children: (_f = (_e = applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserName }), _jsx(Descriptions.Item, { label: "Email", span: 3, children: (_h = (_g = applicationData.loggedInClient) === null || _g === void 0 ? void 0 : _g.userLoginDetails) === null || _h === void 0 ? void 0 : _h.strUserEmailId }), applicationData.userRole === 1 && _jsx(Descriptions.Item, { label: "Subscription Plan", span: 3, children: (_k = (_j = applicationData.subscriptionDetails) === null || _j === void 0 ? void 0 : _j.objLuSubscription) === null || _k === void 0 ? void 0 : _k.strLongDesc }), applicationData.userRole === 1 && ((_l = applicationData.subscriptionDetails) === null || _l === void 0 ? void 0 : _l.dtSubscriptionExpirationDate) &&
                                            _jsx(Descriptions.Item, { label: "Expiring on", span: 3, children: dayjs((_m = applicationData.subscriptionDetails) === null || _m === void 0 ? void 0 : _m.dtSubscriptionExpirationDate, 'DD/MM/YYYY hh:mm:ss').format('DD-MMM-YYYY') })] }), _jsx(LogoutButton, {})] }), _jsx(Divider, {}), _jsx(Menu, { defaultSelectedKeys: ['1'], mode: "inline", items: items, onClick: onClick, theme: "dark" })] }) }), applicationData.userRole === 1 && _jsxs(Col, { xs: 24, sm: 24, md: 24, lg: 18, xl: 19, children: [(parseInt(current) === 1 || parseInt(current) === 2) &&
                        _jsx(Card, { title: parseInt(current) === 1 ? 'Certificate Notifications' : 'Regulation Notifications', style: { borderRadius: '0px' }, extra: _jsx(Button, { type: "primary", onClick: handleSaveProfileDetails, loading: saveButtonLoad, children: saveButtonLoad ? 'Saving Profile Details' : 'Save' }), children: dataFetched && (parseInt(current) === 1 ?
                                _jsx(CertificateNotiForm, { isCertOverdueWeekNotiEnabled: isCertOverdueWeekNotiEnabled, setIsCertOverdueWeekNotiEnabled: setIsCertOverdueWeekNotiEnabled, isCertImpactRemindNotiEnabled: isCertImpactRemindNotiEnabled, setIsCertImpactRemindNotiEnabled: setIsCertImpactRemindNotiEnabled, certFrequency: certFrequency, setCertFrequency: setCertFrequency, certDecisionPeriod: certDecisionPeriod, setCertDecisionPeriod: setCertDecisionPeriod, certRenewalStatus: certRenewalStatus, setCertRenewalStatus: setCertRenewalStatus }) :
                                _jsx(RegulationNotiForm, { isRegNotificationEnabled: isRegNotificationEnabled, setIsRegNotificationEnabled: setIsRegNotificationEnabled, regFrequency: regFrequency, setRegFrequency: setRegFrequency, selMainSubProdList: selMainSubProdList, setSelMainSubProdList: setSelMainSubProdList, selRegCountryList: selRegCountryList, setSelRegCountryList: setSelRegCountryList, selServiceTypeList: selServiceTypeList, setSelServiceTypeList: setSelServiceTypeList })) }), (applicationData.isParentClient && parseInt(current) === 3) && (applicationData.userRole === 1) &&
                        _jsx(Form, { form: multiClientForm, layout: "vertical", name: "Cient-form", onFinish: onMultiClientSelect, children: _jsx(Card, { title: 'Multiple Client', style: { borderRadius: '0px' }, extra: _jsx(Form.Item, { children: _jsx(Button, { type: "primary", htmlType: "submit", children: "Proceed" }) }), children: _jsx(MultipleClientForm, { form: multiClientForm }) }) })] })] }));
};
